<template>
  <div class="notes">
    <img src="../../assets/imgs/music-notes/note-01.png" ref="note01" class="note-01" />
    <img src="../../assets/imgs/music-notes/note-02.png" ref="note02" class="note-02" />
    <img src="../../assets/imgs/music-notes/note-03.png" ref="note03" class="note-03" />
    <img src="../../assets/imgs/music-notes/note-04.png" ref="note04" class="note-04" />
  </div>
</template>

<script>
import gsap from 'gsap';

export default {
  name: "LargeNotes",
  data() {
    return {
      lang: []
    }
  },
  props: {
    showNotes: {
      type: String,
      default: ''
    },
  },
  mounted() {
    if(this.showNotes == 'one') {
      this.startNotes();
    } else {
      this.startNotesTwo();
    }
    
  },
	methods: {
		startNotes() {
      var note4 = gsap.timeline({repeat: -1});
      note4.set(this.$refs.note04, { x: 280, y: 70, opacity: 0});
      note4.to(this.$refs.note04, { x: 290, y: 60, opacity: 1, duration: 2, ease: "power2.out"});      
      note4.to(this.$refs.note04, { x: 300, y: 50, opacity: 0, duration: 1, ease: "power2.in"});

      var note1 = gsap.timeline({repeat: -1});
      note1.set(this.$refs.note01, { x: 330, y: 70, opacity: 0});
      note1.to(this.$refs.note01, { x: 340, y: 55, opacity: 1, rotate: 80, duration: 1, ease: "power2.out"});      
      note1.to(this.$refs.note01, { x: 350, y: 35, opacity: 0, rotate: 0, duration: 3, ease: "power2.in"});

      var note2 = gsap.timeline({repeat: -1});
      note2.set(this.$refs.note02, { x: 300, y: 60, opacity: 0});
      note2.to(this.$refs.note02, { x: 300, y: 45, opacity: 1, duration: 3, ease: "power2.out"});      
      note2.to(this.$refs.note02, { x: 310, y: 25, opacity: 0, duration: 3, ease: "power2.in"});

      var note3 = gsap.timeline({repeat: -1});
      note3.set(this.$refs.note03, { x: 250, y: 90, opacity: 0});
      note3.to(this.$refs.note03, { x: 270, y: 20, opacity: 1, duration: 4, ease: "power2.in"});      
      note3.to(this.$refs.note03, { x: 270, y: 0, opacity: 0, duration: 1, ease: "power2.out"});

		},
		startNotesTwo() {
      var note4 = gsap.timeline({repeat: -1});
      note4.set(this.$refs.note04, { x: 0, y: 30, opacity: 0});
      note4.to(this.$refs.note04, { x: 10, y: 20, opacity: 1, duration: 2, ease: "power2.in"});      
      note4.to(this.$refs.note04, { x: 20, y: 10, opacity: 0, duration: 1, ease: "power2.out"});

      var note1 = gsap.timeline({repeat: -1});
      note1.set(this.$refs.note01, { x: 30, y: 15, opacity: 0});
      note1.to(this.$refs.note01, { x: 40, y: 0, opacity: 1, rotate: 2, duration: 1, ease: "power2.in"});      
      note1.to(this.$refs.note01, { x: 50, y: -30, opacity: 0, rotate: 0, duration: 1, ease: "power2.out"});

      var note2 = gsap.timeline({repeat: -1});
      note2.set(this.$refs.note02, { x: 0, y: 60, opacity: 0});
      note2.to(this.$refs.note02, { x: 0, y: 5, opacity: 1, duration: 2, ease: "power2.in"});      
      note2.to(this.$refs.note02, { x: 10, y: -25, opacity: 0, duration: 3, ease: "power2.out"});

      var note3 = gsap.timeline({repeat: -1});
      note3.set(this.$refs.note03, { x: 70, y: 0, opacity: 0});
      note3.to(this.$refs.note03, { x: 70, y: -20, opacity: 1, duration: 4, ease: "power2.in"});      
      note3.to(this.$refs.note03, { x: 70, y: -40, opacity: 0, duration: 1, ease: "power2.out"});

		}
	}
}
</script>
<style scoped lang="scss">
.notes {
  .note-01 {
    transform: translate(0, 200px);
  }
  .cld-02 {
    transform: translate(0, 100px);
  }
  .cld-03 {
    transform: translate(0, 80px), scale(0.5);
  }
}
</style>
